import { BookOpen } from "lucide-react";

/**
 * =========================================
 * SERMON TILE DESIGN
 * =========================================
 */

const SermonTileDesign = {
  id: "sermon",

  icon: BookOpen,
  label: "Sermon",

  // 🔥 CHURCH THEME
  background: "#5F7D4D",
  color: "#ffffff",
};

export default SermonTileDesign;
